// pages/Unauthorized.js
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './unauthorized.module.css';

const Unauthorized = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.iconWrapper}>
          <i className={`fas fa-exclamation-triangle ${styles.icon}`}></i>
        </div>
        <h1 className={styles.title}>Access Denied</h1>
        <p className={styles.message}>
          You do not have the necessary permissions to view this page.
        </p>
        <Link to="/home" className={styles.backButton}>
          Go Back to Home
        </Link>
      </div>
    </div>
  );
};

export default Unauthorized;
